// extracted by mini-css-extract-plugin
export default {"labelRequired":"shared_labelRequired__G9FYr","fieldHelp":"shared_fieldHelp__mVo2M","fieldError":"shared_fieldError__o8Kfy","section":"shared_section__Bhbf-"};